<div class="confirmation-container">
    <div class="text-container">
        <div [innerHTML]="'SESSION_TIMEOUT_DESC' | translate: {'0': countdown}"></div>
    </div>
    <div class="btn-container">
        <app-button type="primary" label="{{'STAY_LOGGED_IN' | translate}}"
            (click)="onStayLoggedIn()" [bypassPermCheck]="true"></app-button>
    </div>
</div>